import { render, staticRenderFns } from "./collageTotal.vue?vue&type=template&id=a0449082&"
import script from "./collageTotal.vue?vue&type=script&lang=js&"
export * from "./collageTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports